import React from "react";
import Coinpayments from 'coinpayments';
import axios from 'axios';
import { Mutation } from "react-apollo";
import { ADD_NEW_OFFER } from "../../../queries";
import { ADD_PAYPAL_REQUEST, ADD_PAYEER_REQUEST } from "../../../queries";
import ArnoBronze from "../../../img/IndexMain/arno-bronze.png";
import check from "../../../img/IndexMain/check.svg";
import Payeer from "../Offers/Payeer";

import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";

class BronzeOffer2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reload: this.props.reload,
            SumBronze: '',
            CurrenCourse: 2,
            PaymentCoinSum: 0,
            SITE_ADDRESS: "https://launch.artyfact.game",
            email: this.props.session.email,
            agent: this.props.session.Agent,
            fullname: this.props.session.Name + ' ' + this.props.session.Surname,
            currency1: 'USD',
            currency2: 'BTC',
            OfferName: 'Bronze package',
            item: 'Buying ARNO coins',
            MerchSettings: {
                key: 'ecd5a492c7b8bf25932841e723bc74818e8c350f652954d5fd2bcd68e7810e5c',
                secret: '953a4463172DB8661616b78C29dD6DAd770be24fdD4536A1A21E042a24cd8a27'
            },
            CoinpaymentsRatesOpts: {
                short: 1,
                accepted: 2
            },
            rates: {},
            request_id: '',
            status: 0,
            Transaction: '',

            sending: false,
            //PayPal
            clientID: 'fake', //real
            secretKey: 'fake', //real
            hostname: 'api.paypal.com',
            sendRequest: false,
            paidReq: false,
            accessToken: null,
            name: this.props.session.Name,
            surname: this.props.session.Surname,
            requestID: '',
            requestStatus: '',
            requestLink: '',
            captureID: false,

            //Payeer
            payeerMerch: '1287030968',
            payeerSecret: '123',
            payeerCurr: 'USD',
            requestPayeerID: '',
            requestPayeerLink: ''
        };
        
        this.ChangeElement = this.ChangeElement.bind(this);
        this.ChangeElement2 = this.ChangeElement2.bind(this);
        this.SumValidate = this.SumValidate.bind(this);
        this.UpdateRates = this.UpdateRates.bind(this);
        this.BuyPackage = this.BuyPackage.bind(this);
    }

    async componentDidMount(){
        let CetRates = await axios.post(`${this.state.SITE_ADDRESS}/getrates`, this.state.CoinpaymentsRatesOpts);
        if (CetRates.data){
            this.setState({rates: CetRates});
            //console.log(CetRates.data);
            this.GetRates(this.state.SumBronze, this.state.currency2);
            setInterval(this.UpdateRates, 60 * 1000);
        }

        console.log("this.state.SITE_ADDRESS", this.state.SITE_ADDRESS);

        //PayPal
        let self = this;
        await axios.request({
            url: `https://${this.state.hostname}/v1/oauth2/token`,
            method: "post",
            headers:{
                Accept: "application/json",
                "Accept-Language": "en_US",
                "Content-Type": "application/x-www-form-urlencoded"
            },
            auth: {
              username: this.state.clientID,
              password: this.state.secretKey
            },
            params: {
                grant_type: 'client_credentials'
            }
        }).then(res => {
            self.setState({accessToken: res.data.access_token});
        });
    }

    async UpdateRates() {
        let CetRates = await axios.post(`${this.state.SITE_ADDRESS}/getrates`, this.state.CoinpaymentsRatesOpts);
        if (CetRates.data){
            this.setState({rates: CetRates});
            this.GetRates(this.state.SumBronze, this.state.currency2);
        }
    }

    ChangeElement = event => {
        let value = event.target.value.replace(/[^1234567890]/g, ''); // Я убираю все буквы (не даю их вводить)
        /*if (value.length == 2) {
            if (value < 30) { value = 30; } 
            this.setState({SumBronze : value});
        }*/
        if (value.length >= 3) {
            if (value > 299) { value = 299; } 
            this.setState({SumBronze : value});
        } else {
            this.setState({SumBronze : value});
        }      
        this.GetRates(value, this.state.currency2);  
    };   

    GetRates(val, currency) {
        let rates = this.state.rates;
        if (currency == 'paypal' || currency == 'payeer') {
            this.setState({PaymentCoinSum : val * 2});
        } else {
            if (rates.data) {            
                let CostBTC = 1/(rates.data.USD.rate_btc);            
                let BTCsum = rates.data.USD.rate_btc * this.state.CurrenCourse * val;            
                let CostCurCoin = BTCsum/rates.data[`${currency}`].rate_btc;            
                this.setState({PaymentCoinSum : CostCurCoin.toFixed(5)});
            }
        }        
    }
    
    ChangeElement2 = event => {
        let value = event.target.value;
        this.setState({currency2 : value});
        this.GetRates(this.state.SumBronze, value);
    };

    SumValidate = event => {
        let validate = true;
        if (+this.state.SumBronze < 30 || +this.state.SumBronze >= 300) {
            validate = false;
        }
        return validate;
    }; 

    async BuyPackage(event) {
        this.setState({sending : true});
        if (document.getElementById('silver-bot')) { document.getElementById('silver-bot').classList.add("hidden"); }
        if (document.getElementById('gold-bot')) { document.getElementById('gold-bot').classList.add("hidden"); }
        if (document.getElementById('silver-bot-paypal')) { document.getElementById('silver-bot-paypal').classList.add("hidden"); }
        if (document.getElementById('gold-bot-paypal')) { document.getElementById('gold-bot-paypal').classList.add("hidden"); }
        document.getElementById('silver-bot-dis').classList.remove("hidden");
        document.getElementById('gold-bot-dis').classList.remove("hidden");
        const client = new Coinpayments(this.state.MerchSettings);
        let CoinpaymentsCreateTransactionOpts = {
            currency1: this.state.currency1,
            currency2: this.state.currency2,
            amount: this.state.SumBronze * this.state.CurrenCourse,
            buyer_email: this.state.email,
            buyer_name: this.state.fullname,
            item_name: this.state.OfferName,
            custom: this.state.item,
            success_url: `${this.state.SITE_ADDRESS}/withdrawal`,
            cancel_url: `${this.state.SITE_ADDRESS}/withdrawal`
        };

        const Transaction = await axios.post(`${this.state.SITE_ADDRESS}/transaction`, CoinpaymentsCreateTransactionOpts);
        if (Transaction.data) {
            //console.log(Transaction.data);
            this.setState({Transaction: Transaction.data, request_id: Transaction.data.txn_id});
            document.getElementById('PayButton').click();
        }    
       /* const Transaction = await client.createTransaction(CoinpaymentsCreateTransactionOpts);
        if (Transaction) {
            console.log(Transaction);
            this.setState({Transaction: Transaction, request_id: Transaction.txn_id});
            document.getElementById('PayButton').click();
        }*/
    }

    addNewOfferEvent = (event, addNewOffer) => {
        event.preventDefault();        
        addNewOffer().then(({ data }) => {
            console.log('addNewOffer', data.addNewOffer);
            this.setState({sending : false});
            document.getElementById('silver-bot-dis').classList.add("hidden");
            document.getElementById('gold-bot-dis').classList.add("hidden");
            if (document.getElementById('silver-bot')) { document.getElementById('silver-bot').classList.remove("hidden"); }
            if (document.getElementById('gold-bot')) { document.getElementById('gold-bot').classList.remove("hidden"); }
            if (document.getElementById('silver-bot-paypal')) { document.getElementById('silver-bot-paypal').classList.remove("hidden"); }
            if (document.getElementById('gold-bot-paypal')) { document.getElementById('gold-bot-paypal').classList.remove("hidden"); }
            window.open(`${this.state.Transaction.checkout_url}`, '_blank');
            if (this.state.reload) {
                window.open(`${this.state.SITE_ADDRESS}/withdrawal`, '_top');
            }
        })
    };  

    //PayPal
    BuyPayPal = event => {
        event.preventDefault();
        this.setState({sending : true});

        if (document.getElementById('silver-bot')) { document.getElementById('silver-bot').classList.add("hidden"); }
        if (document.getElementById('gold-bot')) { document.getElementById('gold-bot').classList.add("hidden"); }
        if (document.getElementById('silver-bot-paypal')) { document.getElementById('silver-bot-paypal').classList.add("hidden"); }
        if (document.getElementById('gold-bot-paypal')) { document.getElementById('gold-bot-paypal').classList.add("hidden"); }
        document.getElementById('silver-bot-dis').classList.remove("hidden");
        document.getElementById('gold-bot-dis').classList.remove("hidden");

        axios.post(`https://${this.state.hostname}/v2/checkout/orders`,
                {
                    "intent": "CAPTURE",
                    "purchase_units": [
                        {   
                            "description": "Payment for crediting ARNO tokens to your personal account on the website https://arno-token.com",
                            "amount": {
                                "currency_code": "USD",
                                "value": `${this.state.PaymentCoinSum}`
                            }
                        }
                    ],
                    "payer": {
                        "name": {
                          "given_name": `${this.state.name}`,
                          "surname": `${this.state.surname}`
                        },
                        "email_address": `${this.state.email}`
                    },
                    "application_context" : {
                        "brand_name": "ARNO",
                        "user_action": "PAY_NOW",
                        "shipping_preference": "NO_SHIPPING",
                        "return_url": `this.state.SITE_ADDRESS}/withdrawal`,
                        "cancel_url": this.state.SITE_ADDRESS
                    }
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.accessToken}`
                    }
                }
            ).then(res => {
                let requestLink = res.data.links.find(data => data.rel == "approve").href;
                this.setState({
                    requestID: res.data.id,
                    requestStatus: res.data.status,
                    requestLink: requestLink,
                    paidReq: true
                });
                document.getElementById('PayButtonPayPal').click();
            });
    }

    addPayPal = (event, addPayPalRequest) => {
        event.preventDefault();
        window.open(`${this.state.requestLink}`, '_blank');
        addPayPalRequest().then(({ data }) => {
            this.setState({sending : false});
            document.getElementById('silver-bot-dis').classList.add("hidden");
            document.getElementById('gold-bot-dis').classList.add("hidden");
            if (document.getElementById('silver-bot')) { document.getElementById('silver-bot').classList.remove("hidden"); }
            if (document.getElementById('gold-bot')) { document.getElementById('gold-bot').classList.remove("hidden"); }
            if (document.getElementById('silver-bot-paypal')) { document.getElementById('silver-bot-paypal').classList.remove("hidden"); }
            if (document.getElementById('gold-bot-paypal')) { document.getElementById('gold-bot-paypal').classList.remove("hidden"); }
            console.log('addPayPalRequest работает', data.addPayPalRequest);
            this.setState({ sendRequest: true });
            if (this.state.reload) {
                window.open(`${this.state.SITE_ADDRESS}/withdrawal`, '_top');
            }
        })
    };  

    //Payeer
    BuyPayeer = event => {
        event.preventDefault();
        this.setState({sending : true});

        let payeerAPI = new Payeer(this.state.payeerMerch , this.state.payeerSecret, this.state.payeerCurr);
        let paeerIDreq = `${Date.now()}`.slice(8);
        
        const promise = new Promise((resolve, reject) => {
            let payeerLink = payeerAPI.getLinkToPay(paeerIDreq, this.state.PaymentCoinSum, 'Payment for crediting ARNO tokens to your personal account on the website https://arno-token.com');
            if(payeerLink) {
                resolve(payeerLink);
            } else {
                reject(new Error('Что-то пошло не так'));
            }
        });

        promise.then((data) => {
            this.setState({requestPayeerID: paeerIDreq, requestPayeerLink: data});

            if (document.getElementById('silver-bot')) { document.getElementById('silver-bot').classList.add("hidden"); }
            if (document.getElementById('gold-bot')) { document.getElementById('gold-bot').classList.add("hidden"); }
            if (document.getElementById('silver-bot-paypal')) { document.getElementById('silver-bot-paypal').classList.add("hidden"); }
            if (document.getElementById('gold-bot-paypal')) { document.getElementById('gold-bot-paypal').classList.add("hidden"); }
            document.getElementById('silver-bot-dis').classList.remove("hidden");
            document.getElementById('gold-bot-dis').classList.remove("hidden");

            document.getElementById('PayButtonPayeer').click();
        });
    }

    addPayeer = (event, addPayeerRequest) => {
        event.preventDefault();
        window.open(`${this.state.requestPayeerLink}`, '_blank');
        addPayeerRequest().then(({ data }) => {
            this.setState({sending : false});
            document.getElementById('silver-bot-dis').classList.add("hidden");
            document.getElementById('gold-bot-dis').classList.add("hidden");
            if (document.getElementById('silver-bot')) { document.getElementById('silver-bot').classList.remove("hidden"); }
            if (document.getElementById('gold-bot')) { document.getElementById('gold-bot').classList.remove("hidden"); }
            if (document.getElementById('silver-bot-paypal')) { document.getElementById('silver-bot-paypal').classList.remove("hidden"); }
            if (document.getElementById('gold-bot-paypal')) { document.getElementById('gold-bot-paypal').classList.remove("hidden"); }
            console.log('addPayeerRequest работает', data.addPayeerRequest);
            this.setState({ sendRequest: true });
            if (this.state.reload) {
                window.open(`${this.state.SITE_ADDRESS}/withdrawal`, '_top');
            }
        })
    };  

    render() {
        return (
            <div className="IndexMain ">
            <TopPafeInfo session={this.props.session}/>
            <div className="IndexMainMainPart">

                <div className="IndexMainPackage">
                    <div className="IndexMainElementIn">
                        <div className="StandartElementTitle">PACKAGE OFFERS</div>
                        <div className="StandartElementTopBorder" />
                    </div>
                    <div className="row">
                        <div class="col-md-4 col-sm-12">

            <div class="package-area2">
                <div className="package-ttl2">
                    <img className="package-img2" src={ArnoBronze} /> BRONZE
                </div>
                
                <div className="package-price2">
                    <input className="SumInputDash2" type="text" value={this.state.SumBronze ? this.state.SumBronze : ''} name="SumBronze" placeholder="Enter ammount" onChange={this.ChangeElement}/>
                    <div className="package-price-text2">ARNO</div>
                    <div class="help-sum">{this.state.SumBronze < 30 && 'Minimum 30 ARNO'}</div>
                </div>
                
                <div className="custom-separator"></div>

                
                <div className="payment-type-area">
                    <div className="PaymentCoin2">
                        Payment Coin:
                    </div>
                    <div className="PaymentSelection2">
                        <label>
                            <select value={this.state.currency2 ? this.state.currency2 : ''} name="currency2" onChange={this.ChangeElement2}>           
                                <option value="BTC">BTC</option>
                                <option value="ETH">ETH</option>
                                <option value="LTC">LTC</option>
                                {/*<option value="USDT.ERC20">USDT</option>*/}
                                <option value="BCH">BCH</option>
                                <option value="XMR">XMR</option>
                                <option value="DASH">DASH</option>
                                <option value="DOGE">DOGE</option>
                                <option value="paypal">PayPal</option>
                                <option value="payeer">Payeer</option>
                            </select>
                        </label>
                    </div>
                </div>

                <div className="PaymentCoinSum2">
                   = {this.state.PaymentCoinSum} {this.state.currency2 == 'paypal' || this.state.currency2 == 'payeer' ? 'USD' : this.state.currency2}
                </div> 

                <ul class="list-package">
                    <li class="mb-3">
                        <img className="check-img" src={check}/> 30-299 ARNO
                    </li>
                    <li class="mb-3">
                        <img className="check-img" src={check}/> Cashback 10%
                    </li>
                </ul>

                <div className="total-arno">
                    Total with cashback:
                </div>
                <div className="total-arno-sum">
                    {(this.state.SumBronze && this.state.SumBronze >= 30 && this.state.SumBronze < 300) && '= ' + (this.state.SumBronze * 1.1).toFixed(2)} ARNO
                </div>
                
                { this.SumValidate() ? (
                    <>
                    { this.state.sending ? (
                        <div class="package-but" id="bronze-bot-dis">
                            PLEASE WAIT
                        </div>
                    ) : (
                        <>

                        { this.state.currency2 == 'paypal' ? ( 
                            <div id="bronze-bot-paypal" className="package-but buy-botton" onClick={event => this.BuyPayPal(event)}>
                                BUY ARNO
                            </div>
                        ) : (
                            <>
                            { this.state.currency2 == 'payeer' ? (
                                <div id="bronze-bot-payeer" className="package-but buy-botton" onClick={event => this.BuyPayeer(event)}>
                                    BUY ARNO
                                </div>
                            ) : (
                                <div id="bronze-bot" className="package-but buy-botton" onClick={event => this.BuyPackage(event)}>
                                    BUY ARNO
                                </div>
                            )}
                            </>
                        )}
                        
                        <div id="bronze-bot-dis" class="package-but buy-botton hidden">
                            PLEASE WAIT
                        </div>
                        </>
                    )}
                    <Mutation mutation={ADD_NEW_OFFER} variables={{ 
                        email: this.state.email,
                        agent: this.state.agent ? this.state.agent : '',
                        arno: +this.state.SumBronze,
                        ammount: this.state.SumBronze * this.state.CurrenCourse,
                        coin_ammount: +this.state.Transaction.amount,
                        status: this.state.status,
                        request_id: this.state.request_id,
                        item_name: this.state.OfferName,
                        currency1: this.state.currency1,
                        currency2: this.state.currency2,
                        status_url: this.state.Transaction.status_url,                        
                        payment_time: new Date()
                        }}>
                        {(addNewOffer, { data, loading, error }) => {
                            return (
                                <>                                    
                                    <button id="PayButton" style={{ display: 'none' }} onClick={event => this.addNewOfferEvent(event, addNewOffer)}>Make deposit</button>
                                </>
                            )
                        }}
                    </Mutation>

                    <Mutation mutation={ADD_PAYPAL_REQUEST} variables={{ 
                        email: this.state.email,
                        agent: this.state.agent ? this.state.agent : '',
                        arno: +this.state.SumBronze,
                        value: this.state.SumBronze * this.state.CurrenCourse, 
                        currency: 'USD',
                        request_id: this.state.requestID,
                        item_name: this.state.OfferName,
                        status: this.state.requestStatus,
                        intent: 'CAPTURE',
                        create_time: new Date(),
                        pay_link: this.state.requestLink}}>
                        {(addPayPalRequest, { data, loading, error }) => {
                            return (
                                <div style={{ display: 'none' }} >                                    
                                    <button id="PayButtonPayPal" onClick={event => this.addPayPal(event, addPayPalRequest)} className="ButtonStandart">Make deposit</button>                                    
                                </div>
                            )
                        }}
                    </Mutation>

                    <Mutation mutation={ADD_PAYEER_REQUEST} variables={{ 
                        email: this.state.email,
                        agent: this.state.agent ? this.state.agent : '',
                        arno: +this.state.SumBronze,
                        value: this.state.SumBronze * this.state.CurrenCourse, 
                        currency: this.state.payeerCurr,
                        request_id: this.state.requestPayeerID,
                        item_name: this.state.OfferName,
                        status: 'pending',
                        create_time: new Date(),
                        pay_link: this.state.requestPayeerLink}}>
                        {(addPayeerRequest, { data, loading, error }) => {
                            return (
                                <div style={{ display: 'none' }} >                                    
                                    <button id="PayButtonPayeer" onClick={event => this.addPayeer(event, addPayeerRequest)} className="ButtonStandart">Make deposit</button>                                    
                                </div>
                            )
                        }}
                    </Mutation>
                    </>
                ) : (
                    <div class="package-but-disable buy-botton">
                        BUY ARNO
                    </div>
                )}                
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
        )
    }
}

export default BronzeOffer2